var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error py-5 px-3"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }